import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { CompanyBilling } from '../models/company-billing.model';

@Injectable({
    providedIn: 'root'
})
export class CompanyBillingService {
    private apiUrl = `${environment.apiUrl}/company-billing`;

    constructor(private http: HttpClient) { }

    getAll(params?: any): Observable<CompanyBilling[]> {
        let httpParams = new HttpParams();
        if (params) {
            Object.keys(params).forEach(key => {
                if (params[key] !== null && params[key] !== undefined) {
                    httpParams = httpParams.set(key, params[key]);
                }
            });
        }
        return this.http.get<CompanyBilling[]>(this.apiUrl, { params: httpParams });
    }

    getById(id: number): Observable<CompanyBilling> {
        return this.http.get<CompanyBilling>(`${this.apiUrl}/${id}`);
    }

    getByCompany(companyId: number): Observable<CompanyBilling> {
        return this.http.get<CompanyBilling>(`${this.apiUrl}/company/${companyId}`);
    }

    create(data: Partial<CompanyBilling>): Observable<CompanyBilling> {
        return this.http.post<CompanyBilling>(this.apiUrl, data);
    }

    update(id: number, data: Partial<CompanyBilling>): Observable<CompanyBilling> {
        return this.http.put<CompanyBilling>(`${this.apiUrl}/${id}`, data);
    }

    updateQuotas(id: number, quotas: { monthlyLeadQuota?: number; maxDevices?: number; maxPromotions?: number }): Observable<CompanyBilling> {
        return this.http.patch<CompanyBilling>(`${this.apiUrl}/${id}/quotas`, quotas);
    }

    suspend(id: number): Observable<CompanyBilling> {
        return this.http.put<CompanyBilling>(`${this.apiUrl}/${id}/suspend`, {});
    }

    reactivate(id: number): Observable<CompanyBilling> {
        return this.http.put<CompanyBilling>(`${this.apiUrl}/${id}/reactivate`, {});
    }

    cancelAtPeriodEnd(id: number): Observable<CompanyBilling> {
        return this.http.put<CompanyBilling>(`${this.apiUrl}/${id}/cancel-at-period-end`, {});
    }

    delete(id: number): Observable<void> {
        return this.http.delete<void>(`${this.apiUrl}/${id}`);
    }
}
